import { StateObservable } from 'redux-observable';
import { VariablesEditorDialogAction, State, createOpenWithCopy } from '..';

import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { EpicDependencies } from '../dependencies.interface';

export const fillCopyDataFromApi = (
  actions$: Observable<VariablesEditorDialogAction>,
  state$: StateObservable<State>,
  dependencies: EpicDependencies,
): Observable<VariablesEditorDialogAction> => dependencies.copy$.pipe(map(createOpenWithCopy));
